import { render, staticRenderFns } from "./provider-manage.vue?vue&type=template&id=76e7ad00"
import script from "./provider-manage.vue?vue&type=script&lang=js"
export * from "./provider-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports